// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","spinner-content":"Spinner_spinner-content__1EvZ-","spinner-content__svg":"Spinner_spinner-content__svg__1rLWg","a":"Spinner_a__13c52"};